import { CustomFieldSchema } from 'common/form';
import { ListTeam } from 'generated-graphql/types';
import { TeamFieldState } from 'modules/candidate-profile/forms/schema';
import { TeamField } from 'modules/candidate-profile/forms/components/TeamField';

export const getTeamField = ({
  currentTeams,
  teamState
}: {
  currentTeams: ListTeam[];
  teamState: TeamFieldState;
}): CustomFieldSchema => ({
  type: 'custom',
  label: 'Choose a team',
  render: (props) => (
    <TeamField {...props} currentTeams={currentTeams} teamState={teamState} />
  )
});
